export default {"src":"/_next/static/media/laisse-obligatoire.44ac886b.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};